import { render } from "./CopySpan.vue?vue&type=template&id=b30ebe3c&scoped=true"
import script from "./CopySpan.vue?vue&type=script&lang=js"
export * from "./CopySpan.vue?vue&type=script&lang=js"

import "./CopySpan.vue?vue&type=style&index=0&id=b30ebe3c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b30ebe3c"]])

export default __exports__